import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Button, List, message, Select } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ButtonWrapper } from '../styles';
import { StyledFormItem } from '../../AdInvestigator/styles';
import { connect } from 'dva';

const NewUserModal = ({ dispatch, isModalVisible, setIsModalVisible, roles = [], userData = [] }) => {
  const [form] = Form.useForm();
  const [userRoles, setUserRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);

  const LAYOUT_STYLES = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setUserRoles([]);
  };
  const handleDeleteRole = (role) => {
    setUserRoles(userRoles.filter((r) => r !== role)); // Remove role from the list
  };
  const handleAddRole = () => {
    if (!selectedRole) return;
    const roleToAdd = roles.find((role) => role.name === selectedRole && role.id);
    if (roleToAdd && !userRoles.some((role) => role.id === roleToAdd.id)) {
      setUserRoles((prevRoles) => [...prevRoles, roleToAdd]);
      setSelectedRole(null);
    }
    dispatch({ type: 'permissionManager/fetchUsers' });
  };
  const handleSaveUser = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch (err) {
      // Validation failed, do not proceed
      return;
    }
    const emails = (values.emails || []).map((e) => e.trim()).filter(Boolean);

    if (emails.length === 0) {
      message.error('Please input at least one user email!');
      return;
    }

    const existingEmails = userData.map((user) => user['email-id']?.toLowerCase());
    const newUsers = emails
      .filter((email) => !existingEmails.includes(email.toLowerCase()))
      .map((email) => ({
        email,
        userRoles: userRoles.map((role) => role.id),
      }));

    if (newUsers.length === 0) {
      message.warning('All users already exist');
      return;
    }

    try {
      await dispatch({
        type: 'permissionManager/addUser',
        payload: newUsers,
      });
      dispatch({ type: 'permissionManager/fetchUsers' });
      message.success('User(s) added successfully');
      handleCancel();
    } catch (error) {
      console.error('Error adding user(s):', error);
    }
  };
  useEffect(() => {
    if (isModalVisible) {
      dispatch({ type: 'permissionManager/fetchRoles' });
    }
  }, [isModalVisible, dispatch]);

  return (
    <Modal
      title="Create New User(s)"
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={[
        <ButtonWrapper key="save" onClick={handleSaveUser}>
          Create
        </ButtonWrapper>,
      ]}
    >
      <Form form={form} layout="vertical">
        <StyledFormItem
          label="User Email(s)"
          name="emails"
          rules={[
            {
              validator: (_, value) => {
                if (!value || value.length === 0) {
                  return Promise.reject('Please input at least one user email!');
                }
                const invalid = value.find(
                  (email) => !email || !email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
                );
                return invalid ? Promise.reject(`Invalid or blank email: "${invalid}"`) : Promise.resolve();
              },
            },
          ]}
        >
          <Select
            mode="tags"
            style={{ width: '100%' }}
            placeholder="Enter user email(s), press Enter after each"
            tokenSeparators={[',', ' ']}
          />
        </StyledFormItem>
        <h3>Roles</h3>
        <List
          dataSource={userRoles}
          renderItem={(role) => (
            <List.Item
              actions={[<Button type="text" icon={<DeleteOutlined />} onClick={() => handleDeleteRole(role)} />]}
            >
              {role.name}
            </List.Item>
          )}
        />
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px', flexWrap: 'wrap' }}>
          <Select
            style={{ flex: 1, marginRight: '8px' }}
            placeholder="Select a role"
            value={selectedRole}
            onChange={(value) => setSelectedRole(value)}
          >
            {(roles || []).map((role) => (
              <Select.Option key={role.id} value={role.name}>
                {role.name}
              </Select.Option>
            ))}
          </Select>
          <ButtonWrapper onClick={handleAddRole}>Add Role</ButtonWrapper>
        </div>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  roles: state.permissionManager.roles || [],
  userData: state.permissionManager.userData || [],
});

export default connect(mapStateToProps)(NewUserModal);
